import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { IKCard, KCardFieldType } from 'ng-k-card';
import { GlobalLoadingService } from 'src/app/services/global-loading.service';
import { KIconType } from 'ng-k-icon';
import { KInputType } from 'ng-k-form';
import { FormBuilder, Validators, FormGroup, AbstractControl, ValidationErrors, ValidatorFn, FormControl } from '@angular/forms';
import { KButtonType, KKcgButtonSubType } from 'ng-k-button';
import { request } from 'http';
import { ClaimsService } from 'src/app/services/claims.service';
import { NihlOutlineExposureService } from 'src/app/services/nihl-outline-exposure.service';
import { OauthPlusService } from 'src/app/services/oauth-plus.service';
import { KListItem } from 'ng-k-utils';
import { ChangeDetectorRef } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-audiometry-form',
  templateUrl: './audiometry-form.component.html',
  styleUrls: ['./audiometry-form.component.scss']
})

export class AudiometryFormComponent implements OnInit {
  public claimInfo: IKCard = {};
  public claimData: any = [];
  public claimId = '';
  public taskId = '';
  public dynamicNumberInput: any = KInputType['number'];
  public dynamicStringInput: any = KInputType['string'];
  public dynamicDateInput: any = KInputType['datepicker'];
  public dynamicDropDownInput: any = KInputType['dropdown'];
  public audiometryTestForm: any = {};
  public employerList: { label: string, value: any }[] = [];
  public audiometryTypeList: { label: string, value: any }[] = [];
  public tinnitusList: { label: string, value: any }[] = [];
  public isSubmitted = false;
  KButtonType = KButtonType;
  KKcgButtonSubType = KKcgButtonSubType;
  public testId = '';
  public notExpTaskId = '';


  public successText!: string;
  public displaySuccess: boolean = false;
  public timeout!: number;
  public errorText: string = ''
  public displayError: boolean = false;
  public workflowData = [];
  public outlineExposureTaskId = ''
  public saveAudiometryButton: boolean = false;

  public audiologistList: KListItem[] = [];

  // Set DOB for date validation;

  public DOB: Date;
  public hideEmployer: boolean = false;

  public customClaimData: any;
  public customData: any;

  public notionalExposureOptions = [
    {
      "label": "85",
      "value": 85
    },
    {
      "label": "86",
      "value": 86
    },
    {
      "label": "87",
      "value": 87
    },
    {
      "label": "88",
      "value": 88
    },
    {
      "label": "89",
      "value": 89
    },
    {
      "label": "90",
      "value": 90
    },
    {
      "label": "91",
      "value": 91
    },
    {
      "label": "92",
      "value": 92
    },
    {
      "label": "93",
      "value": 93
    },
    {
      "label": "94",
      "value": 94
    },
    {
      "label": "95",
      "value": 95
    },
    {
      "label": "96",
      "value": 96
    },
    {
      "label": "97",
      "value": 97
    },
    {
      "label": "98",
      "value": 98
    },
    {
      "label": "99",
      "value": 99
    },
    {
      "label": "100",
      "value": 100
    },
    {
      "label": "101",
      "value": 101
    },
    {
      "label": "102",
      "value": 102
    },
    {
      "label": "103",
      "value": 103
    },
    {
      "label": "104",
      "value": 104
    },
    {
      "label": "105",
      "value": 105
    },
    {
      "label": "106",
      "value": 106
    },
    {
      "label": "107",
      "value": 107
    },
    {
      "label": "108",
      "value": 108
    },
    {
      "label": "109",
      "value": 109
    },
    {
      "label": "110",
      "value": 110
    },
    {
      "label": "111",
      "value": 111
    },
    {
      "label": "112",
      "value": 112
    },
    {
      "label": "113",
      "value": 113
    },
    {
      "label": "114",
      "value": 114
    },
    {
      "label": "115",
      "value": 115
    },
    {
      "label": "116",
      "value": 116
    },
    {
      "label": "117",
      "value": 117
    },
    {
      "label": "118",
      "value": 118
    },
    {
      "label": "119",
      "value": 119
    },
    {
      "label": "120",
      "value": 120
    },
    {
      "label": "121",
      "value": 121
    },
    {
      "label": "122",
      "value": 122
    },
    {
      "label": "123",
      "value": 123
    },
    {
      "label": "124",
      "value": 124
    },
    {
      "label": "125",
      "value": 125
    }
  ];

  sourceURL: string = environment.apiUrl + "nihl/audiologist-list";

  constructor(
    private route: ActivatedRoute,
    private loaderService: GlobalLoadingService,
    private fb: FormBuilder,
    private claimsService: ClaimsService,
    private _auth: OauthPlusService,
    private nihlOutlineExposureService: NihlOutlineExposureService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {
    this.audiometryTestForm = fb.group({
      employerName: [''],
      notionalExposure: ['', Validators.required],
      audiometryType: ['', Validators.required],
      yearsExposedToNoise: ['', [Validators.required, this.negativeValueValidator, this.rangeValidator(1, 49)]],
      r250hz: ['', [Validators.min(-50), Validators.max(130)]],
      r500hz: ['', [Validators.min(-50), Validators.max(130)]],
      r1000hz: ['', [Validators.required, Validators.min(-50), Validators.max(130)]],
      r2000hz: ['', [Validators.min(-50), Validators.max(130)]],
      r3000hz: ['', [Validators.min(-50), Validators.max(130)]],
      r4000hz: ['', [Validators.min(-50), Validators.max(130)]],
      r6000hz: ['', [Validators.min(-50), Validators.max(130)]],
      r8000hz: ['', [Validators.required, Validators.min(-50), Validators.max(130)]],
      l250hz: ['', [Validators.min(-50), Validators.max(130)]],
      l500hz: ['', [Validators.min(-50), Validators.max(130)]],
      l1000hz: ['', [Validators.required, Validators.min(-50), Validators.max(130)]],
      l2000hz: ['', [Validators.min(-50), Validators.max(130)]],
      l3000hz: ['', [Validators.min(-50), Validators.max(130)]],
      l4000hz: ['', [Validators.min(-50), Validators.max(130)]],
      l6000hz: ['', [Validators.min(-50), Validators.max(130)]],
      l8000hz: ['', [Validators.required, Validators.min(-50), Validators.max(130)]],
      audiologist: ['', [Validators.required, this.isValidAudiologistName()]],
      audiogramDate: ['', [Validators.required, this.dateValidator()]],
      loss: ['', [Validators.min(-10), Validators.max(70), this.integerValidator()]],
      tinnitus: ['', [Validators.required]],
      // applytdh39Correction: ['', Validators.required],
      allowAnchor6KHz: ['', Validators.required]
    });
    this.audiometryTestForm.get('audiometryType').valueChanges.subscribe(() => {
      this.updateValidationBasedOnAudiometryType();
    });
    // this.audiometryTestForm.get('audiologist').valueChanges.subscribe(() => {
    //   this.suggestAudiologist();
    // });
  }



  isValidAudiologistName(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {


      if (!control.hasValidator(Validators.required)) {
        return null;
      }

      const name = control.value;
      if (name) {
        const cleanedName = name.trim().replace(/\s{2,}/gm, " ");
        if (cleanedName.length < 10) {
          return { invalidCharacterLength: true };
        }
      }

      // // 1. Disallowed prefixes
      // const titles = ["Mr", "Mrs", "Ms", "Dr", "Prof", "Sir", "Madam"];

      // // 2. Trim and split the name
      // const trimmed = name.trim();
      // const parts = trimmed.split(/\s+/); // split by one or more spaces

      // // 3. Reject if first word is a title
      // if (titles.includes(parts[0])) {
      //   return { disallowedPrefix: true};
      // }

      // // 4. Must be either 2 or 3 parts (First Last or First Middle Last)
      // if (parts.length < 2 || parts.length > 3) {
      //   return { invalidName: true};
      // }

      // // 5. Validate each part starts with a capital letter, followed by valid letters
      // const isValidPart = (part:string) => {
      //   if (!/^[A-Z]/.test(part)) return false;
      //   return /^[A-Za-z'’-]+$/.test(part);
      // };

      // const isValid = parts.every(isValidPart);
      // if(!isValid){
      //   return { invalidCharacters: true};
      // }
      return null;
    }
  }

  /**
   *  Update some validations
   */
  updateValidationBasedOnAudiometryType(): void {
    /**
     *  If audiometryType = 'Hospital' or 'Occupational Health'
     *      Audiologist Name is not required
     *  else if audiometryType = 'Claimant Medico-Legal' or 'Claimant Repeat Test'
     *      Overall Binaural Hearing Loss (dB) is required
     */

    let atc: FormControl = this.audiometryTestForm.get('audiometryType');
    switch (atc.value) {
      case "Hospital":
      case "Occupational Health":
        this.audiometryTestForm.controls["audiologist"].removeValidators([
          Validators.required
        ]);
        this.audiometryTestForm.controls["loss"].removeValidators([
          Validators.required
        ]);
        this.audiometryTestForm.controls["audiologist"].updateValueAndValidity({ onlySelf: true, emitEvent: false });
        this.audiometryTestForm.controls["loss"].updateValueAndValidity({ onlySelf: true, emitEvent: false });
        break;
      case "Claimant Medico-Legal":
      case "Claimant Repeat Test":
        this.audiometryTestForm.controls["loss"].addValidators([
          Validators.required
        ]);
        this.audiometryTestForm.controls["audiologist"].addValidators([
          Validators.required
        ]);
        this.audiometryTestForm.controls["loss"].updateValueAndValidity({ onlySelf: true, emitEvent: false });
        this.audiometryTestForm.controls["audiologist"].updateValueAndValidity({ onlySelf: true, emitEvent: false });
        break;
      default:
        this.audiometryTestForm.controls["audiologist"].addValidators([
          Validators.required
        ]);
        this.audiometryTestForm.controls["loss"].removeValidators([
          Validators.required
        ]);
        this.audiometryTestForm.controls["loss"].updateValueAndValidity({ onlySelf: true, emitEvent: false });
        this.audiometryTestForm.controls["audiologist"].updateValueAndValidity({ onlySelf: true, emitEvent: false });
        break;
    }

  }

  isMandatory(control: string) {
    let afc: FormControl = this.audiometryTestForm.get(control)
    //console.log( afc.hasValidator(Validators.required));
    return afc.hasValidator(Validators.required);
  }

  dateValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      if (!this.DOB) {
        return null;
      }

      if (!value) {
        return null;
      }
      return this.DOB.getTime() > value.getTime() ? { invalidDate: true } : null;
    }
  }

  integerValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (value === null || value === '') {
        return null;
      }
      return Number.isInteger(Number(value)) ? null : { notInteger: true };
    };
  }

  negativeValueValidator(control: any) {
    if (control.value < 0) {
      return { negative: true };
    }
    return null; // Return null if no error
  }

  rangeValidator(min: number, max: number): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      if (control.value < min || control.value > max) {
        return { 'range': true };
      }
      return null;
    };
  }


  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.claimId = decodeURIComponent(params['claimId']);
      this.taskId = decodeURIComponent(params['taskId'])

      if (params['testId']) {
        this.testId = decodeURIComponent(params['testId']);
        // this.getAudiometryTestDataById(this.testId);
      }
    });

    this.getClaimInfo(this.claimId);
    this.getClaimInfoCard(this.claimId);
    this._auth.$whenUserLoaded.subscribe(data => {
      if (data) {
        this.getEmploymentList(this.claimId);
      }
    });
    this.getAudiometryTypes();
    this.getTinnitusList();
  }


  public getAudiometryTestDataById(testId: any) {
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = this.claimId ? this.claimId : null;
    requestParam.taskId = this.taskId ? this.taskId : null;
    requestParam.actionName = "audiometry_view_by_id";
    requestParam.payload = {
      "id": testId
    }
    this.loaderService.startLoadingIndicator('getAudiometryTestDataById');

    thisObj.nihlOutlineExposureService.getAudiometryTestDataById(requestParam).subscribe(result => {
      if (result.status === 'Success') {
        if (result.data.isValid) {
          this.loaderService.stopLoadingIndicator('getAudiometryTestDataById');
          if (!result.data.data.employer) {
            this.hideEmployer = true;
          }
          this.customData = {
            ...this.customClaimData,
            audiometryType: result.data.data.type,
            testId: testId,
            taskId: this.taskId
          }
          this.audiometryTestForm.patchValue({
            employerName: result.data.data.employer,
            audiometryType: result.data.data.type,
            yearsExposedToNoise: result.data.data.yearsExposedToNoise,
            r250hz: result.data.data.rightEar['250hz'],
            r500hz: result.data.data.rightEar['500hz'],
            r1000hz: result.data.data.rightEar['1000hz'],
            r2000hz: result.data.data.rightEar['2000hz'],
            r3000hz: result.data.data.rightEar['3000hz'],
            r4000hz: result.data.data.rightEar['4000hz'],
            r6000hz: result.data.data.rightEar['6000hz'],
            r8000hz: result.data.data.rightEar['8000hz'],
            l250hz: result.data.data.leftEar['250hz'],
            l500hz: result.data.data.leftEar['500hz'],
            l1000hz: result.data.data.leftEar['1000hz'],
            l2000hz: result.data.data.leftEar['2000hz'],
            l3000hz: result.data.data.leftEar['3000hz'],
            l4000hz: result.data.data.leftEar['4000hz'],
            l6000hz: result.data.data.leftEar['6000hz'],
            l8000hz: result.data.data.leftEar['8000hz'],
            audiogramDate: new Date(result.data.data.audiogramDate),
            audiologist: result.data.data.audiologist,
            tinnitus: result.data.data.tinnitus,
            loss: result.data.data.loss,
            // applytdh39Correction: result.data[0].tdh39,
            allowAnchor6KHz: result.data.data.anchorAt6kHZ,
            notionalExposure: result.data.data.notionalExposure
          });
          if (!result.data.data.notionalExposure) {
            setTimeout(() => {
              this.getNotionalExposure(result.data.data.employer)
            }, 100);
          }
        } else {
          this.errorText = result.data.errors;
          this.showMessage('error', 2000);
          setTimeout(() => {
            this.loaderService.stopLoadingIndicator('getAudiometryTestDataById');
            this.router.navigate(['/claimDetail/', this.claimId]);
          }, 2002);
        }

      }
    },
      err => {
        console.log(err.error);
        this.loaderService.stopLoadingIndicator('getAudiometryTestDataById');
      });
  }

  public getEmploymentList(claimId: any) {
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = claimId ? claimId : null;
    this.loaderService.startLoadingIndicator('getEmploymentList');

    thisObj.nihlOutlineExposureService.getEmploymentList(requestParam).subscribe(result => {
      if (result.status === 'Success') {
        this.loaderService.stopLoadingIndicator('getEmploymentList');
        // this.employmentListData = result.data;
        for (let temp of result.data) {
          this.employerList.push({ label: temp.employer, value: temp.employer });
        }
      }
    },
      err => {
        console.log('err')
        console.log(err.error);
        this.loaderService.stopLoadingIndicator('getEmploymentList');
      });
  }

  public getClaimInfo(claimId: any) {
    // console.log('inside getWorkflow Overview function')
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = claimId ? claimId : null;
    this.loaderService.startLoadingIndicator('getClaimInfo');

    thisObj.claimsService.getWorkflowOverview(requestParam).subscribe(result => {
      if (result.status === 'Success') {
        this.loaderService.stopLoadingIndicator('getClaimInfo');
        this.claimData = result.data.meta;
        console.log(this.claimData.claimant.claimantName)
        this.customClaimData =
        {
          claimId: this.claimId,
          claimantName: this.claimData.claimant.claimantName,
          medicalConditionLabel: 'NIHL',
          medicalConditionValue: 'nihl'
        }
        if (!this.testId) {
          this.customData = this.customClaimData
        }
        this.DOB = new Date(this.claimData?.claimant?.dateOfBirth);
        this.workflowData = result.data.overview;
        for (var i = 0; i < result.data.overview.length; i++) {
          if (result.data.overview[i].workFlowNodeName == 'Investigation') {
            for (var j = 0; j < result.data.overview[i].tasks.length; j++) {
              // console.log(result.data.overview[i].tasks[j]);
              if (result.data.overview[i].tasks[j].handle == 'outline-exposure') {
                this.outlineExposureTaskId = result.data.overview[i].tasks[j].taskId;
              }
              // console.log(this.outlineExposureTaskId)
            }

          }
        }
        this.getClaimInfoCard(this.claimId);
        if (this.testId) {
          this.getAudiometryTestDataById(this.testId);
        }
      }
    },
      err => {
        console.log('err')
        console.log(err.error);
      });
  }

  public getClaimInfoCard(claimId: any) {
    // console.log(this.claimData['claim'].createdDate)
    this.loaderService.startLoadingIndicator('getClaimInfo');
    this.claimInfo = {
      value: '',
      header: {
        label: moment(new Date(this.claimData?.claim?.createdDate)).format('DD/MM/YYYY'),
        labelColour: 'brand-main',
        icon: {
          type: KIconType.fas,
          name: 'clock'
        }
      },
      clickable: false,
      fields: [
        {
          fieldType: KCardFieldType.IdRef,
          label: 'Claim Reference',
          value: this.claimData?.claimant?.claimReference ? this.claimData?.claimant?.claimReference : ' ',
          icon: {
            type: KIconType.fas,
            name: 'tag',
            border: true
          }
        },
        {
          fieldType: KCardFieldType.Text,
          label: 'Claimant Name',
          value: this.claimData?.claimant?.claimantName,
          icon: {
            type: KIconType.fas,
            name: 'user',
            border: true
          }
        },
        {
          fieldType: KCardFieldType.Text,
          label: 'Condition',
          value: this.claimData?.claimant?.condition,
          icon: {
            type: KIconType.fas,
            name: 'stethoscope',
            border: true
          }
        },
        {
          fieldType: KCardFieldType.Link,
          label: 'Open >',
          value: '/claimForm/' + encodeURIComponent(this.claimId),
        }
      ]
    }
    this.loaderService.stopLoadingIndicator('getClaimInfo');
  }

  get f() {
    return this.audiometryTestForm.controls;
  }

  public getAudiometryTypes() {
    // let tempList = ['Clinical Medico-legal', 'Defendant Medico-legal', 'Occupational Hygiene', 'Hospital'];
    let tempList = ['Claimant Medico-Legal', 'Claimant Repeat Test', 'Defendant Repeat Test', 'Occupational Health', 'Defendant Medico-legal', 'Hospital'];
    this.audiometryTypeList = tempList.map(temp => ({ label: temp, value: temp })).sort((a, b) => a.label.localeCompare(b.label));
  }

  public getTinnitusList() {
    let templist = ['Not Declared', 'None', 'Slight', 'Mild', 'Moderate', 'Severe', 'Catastrophic'];
    for (let temp of templist) {
      this.tinnitusList.push({ label: temp, value: temp });
    }
  }

  public saveAudiometryForm(form: any) {
    this.isSubmitted = true;
    if (form.status == 'VALID') {
      this.loaderService.startLoadingIndicator('saveAudiometryForm');
      this.saveAudiometryButton = true;
      // console.log(form);
      const thisObj = this;
      const requestParam: any = {};
      requestParam.claimId = this.claimId ? this.claimId : null;
      requestParam.taskId = this.taskId ? this.taskId : null;
      if (this.testId) {
        requestParam.actionName = 'edit_audiometry_form';
        requestParam.payload = {
          "id": this.testId,
          "employer": form.controls.employerName.value,
          "type": form.controls.audiometryType.value,
          "audiologist": form.controls.audiologist.value,
          "tinnitus": form.controls.tinnitus.value,
          "loss": form.controls.loss.value,
          "audiogramDate": moment(new Date(form.controls.audiogramDate.value)).format('DD/MM/YYYY'),
          "notionalExposure": form.controls.notionalExposure.value,
          // "tdh39": form.controls.applytdh39Correction.value,
          "anchorAt6kHZ": form.controls.allowAnchor6KHz.value,
          "yearsExposedToNoise": form.controls.yearsExposedToNoise.value,
          "leftEar": {
            '250hz': form.controls.l250hz.value,
            '500hz': form.controls.l500hz.value,
            '1000hz': form.controls.l1000hz.value,
            '2000hz': form.controls.l2000hz.value,
            '3000hz': form.controls.l3000hz.value,
            '4000hz': form.controls.l4000hz.value,
            '6000hz': form.controls.l6000hz.value,
            '8000hz': form.controls.l8000hz.value
          },
          "rightEar": {
            '250hz': form.controls.r250hz.value,
            '500hz': form.controls.r500hz.value,
            '1000hz': form.controls.r1000hz.value,
            '2000hz': form.controls.r2000hz.value,
            '3000hz': form.controls.r3000hz.value,
            '4000hz': form.controls.r4000hz.value,
            '6000hz': form.controls.r6000hz.value,
            '8000hz': form.controls.r8000hz.value
          }
        }
      } else {
        requestParam.actionName = 'add_audiometry_form';
        requestParam.payload = {
          "employer": form.controls.employerName.value,
          "type": form.controls.audiometryType.value,
          "audiologist": form.controls.audiologist.value,
          "tinnitus": form.controls.tinnitus.value,
          "loss": form.controls.loss.value,
          "audiogramDate": moment(new Date(form.controls.audiogramDate.value)).format('DD/MM/YYYY'),
          "notionalExposure": form.controls.notionalExposure.value,
          // "tdh39": form.controls.applytdh39Correction.value,
          "anchorAt6kHZ": form.controls.allowAnchor6KHz.value,
          "yearsExposedToNoise": form.controls.yearsExposedToNoise.value,
          "leftEar": {
            '250hz': form.controls.l250hz.value,
            '500hz': form.controls.l500hz.value,
            '1000hz': form.controls.l1000hz.value,
            '2000hz': form.controls.l2000hz.value,
            '3000hz': form.controls.l3000hz.value,
            '4000hz': form.controls.l4000hz.value,
            '6000hz': form.controls.l6000hz.value,
            '8000hz': form.controls.l8000hz.value
          },
          "rightEar": {
            '250hz': form.controls.r250hz.value,
            '500hz': form.controls.r500hz.value,
            '1000hz': form.controls.r1000hz.value,
            '2000hz': form.controls.r2000hz.value,
            '3000hz': form.controls.r3000hz.value,
            '4000hz': form.controls.r4000hz.value,
            '6000hz': form.controls.r6000hz.value,
            '8000hz': form.controls.r8000hz.value
          }
        }
      }


      // console.log(requestParam);

      thisObj.claimsService.postWorkflowActivity(requestParam).subscribe(result => {
        if (result.status === 'Success') {
          this.loaderService.stopLoadingIndicator('saveAudiometryForm');
          if (result.data.isValid) {
            if (this.testId != '') {
              this.successText = 'Audiometry test form edited successfully';
            } else {
              this.successText = 'Audiometry test form added successfully';
            }
            let { testId } = result.data.response;

            this.showMessage('success', 2000);
            this.claimsService.getWorkflowFulfill({ claimId: this.claimId }).subscribe(result => {
              //Nothing shows here
            })
            setTimeout(() => {
              this.router.navigate(['nihl/investigation/audiogram-analyse/', this.claimId, this.taskId, testId]);
            }, 2020);
          } else {
            this.loaderService.stopLoadingIndicator('saveAudiometryForm');
            this.errorText = result.data.errors;
            this.showMessage('error', 2000);
            this.saveAudiometryButton = false;
          }
        }
      });
    }
  }

  goToPage() {
    this.router.navigate(['/claimDetail/', this.claimId]);
  }

  public showMessage(msgType: any, timeout: any) {
    this.displaySuccess = false;
    this.displaySuccess = false;
    if (msgType === 'success') {
      this.displaySuccess = true;
    }
    if (msgType === 'error') {
      this.displayError = true;
    }
    if (timeout) {
      this.timeout = timeout;
    }
  }

  getNotionalExposure(employer: any) {
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = this.claimId ? this.claimId : null;
    requestParam.taskId = this.outlineExposureTaskId ? this.outlineExposureTaskId : null;
    requestParam.actionName = "exposure_view_by_employer";
    requestParam.payload = {
      "employer": employer
    }
    this.loaderService.startLoadingIndicator('getNotionalExposure');

    thisObj.nihlOutlineExposureService.getNotionalExposureDataByEmployer(requestParam).subscribe(result => {
      if (result.status === 'Success') {
        this.loaderService.stopLoadingIndicator('getNotionalExposure');
        this.audiometryTestForm.patchValue({
          "notionalExposure": result.data?.notionalExposure || null
        });
      }
    },
      err => {
        console.log('err')
        console.log(err.error);
        this.loaderService.stopLoadingIndicator('getNotionalExposure');
      });
  }

}
